<div class="update-note-dialog-container">
    <div class="edit-note-dialog-header-container">
        <div>  <p class="update-note-dialog-header-text edit-note-item-section-headers">Order Note</p></div>
        <div><p class="update-note-dialog-sub-heading">Update this order note.</p></div>
    </div>

        <div class="edit-note-dialog-container">
                <textarea [value]="note" (input)="onInputChange($event)" class="edit-note-text-aria" name="note" rows="4" cols="50" wrap="soft"></textarea>
        </div>

    <div class="order-note-btn-dialog-container">

        <button class="cancel-note-dialog-btn" mat-flat-button type="button" (click)="cancelUpdatingNote()">
            <div class="cancel-alt-btn-content">
                <span><p class="cancel-alt-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="update-order-note-btn" mat-flat-button type="button" (click)="updateNewOrderNote()">
            <div class="update-order-note-btn-content">
                <span><p class="update-order-note-btn-text">UPDATE NOTE</p></span>
            </div>
        </button>
    </div>

</div>

